
import { defineComponent, onMounted, onUnmounted } from '@vue/runtime-core'
import { watch, computed } from 'vue'
import ConversationItem from '@/components/messenger/ConversationItem.vue'
import { useUser } from '@/mixins'
import { useStore } from 'vuex'
import { User } from '@/models/auth'
import {
  FETCH_CONVERSATION_ITEMS_ACTION,
  LISTEN_CONVERSATION_ITEMS_ACTION
} from '@/store/actions'
import { orderBy, where } from 'firebase/firestore'
export default defineComponent({
  components: {
    ConversationItem
  },
  setup() {
    const { currentUser } = useUser()
    const store = useStore()
    let unsubscribe = (): void | boolean => {
      return false
    }
    const conversations = computed(() => {
      return store.state.conversations.items
    })
    const loading = computed(() => {
      return store.state.conversations.loading
    })

    const fetchConversations = async () => {
      try {
        await store.dispatch(FETCH_CONVERSATION_ITEMS_ACTION, [
          where('senderPhoneNumber', '==', currentUser.value.phoneNumber),
          orderBy('lastMessage.date', 'desc')
        ])
        unsubscribe = await store.dispatch(LISTEN_CONVERSATION_ITEMS_ACTION, [
          where('senderPhoneNumber', '==', currentUser.value.phoneNumber),
          orderBy('lastMessage.date', 'desc')
        ])
      } catch (e) {
        alert(e)
        console.error(e)
      }
    }

    watch(
      () => currentUser.value,
      (old: User, nuevo: User) => {
        // // console.log('usuario cambio', old, nuevo)
        fetchConversations()
      }
    )
    onMounted(() => {
      //fetchConversations()
    })

    onUnmounted(() => {
      unsubscribe()
    })

    return {
      loading,
      currentUser,
      conversations
    }
  }
})
